import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { environment } from '../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListaAlteracaoLimiteService {

  constructor(
    private httpService: HttpService
  ) { } 

  buscaLimiteGlobal(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  }

  buscaUsuario(data: any, successHandle:Function, errorHandle:Function) {

   return this.httpService.doGet('/employee/product/details', data, successHandle, errorHandle);

 }

 scheduleCharge(data: any, successHandle:Function, errorHandle:Function) {

  return this.httpService.doPost('/employee/product/scheduleChargeLimit', data, successHandle, errorHandle);

  }


}
